import React, { FC } from 'react';

import { getClassNames } from './HighContrastBorder.styles';
import { HighContrastBorderProps } from './HighContrastBorder.types';

const HighContrastBorder: FC<HighContrastBorderProps> = ({
  top = false,
  right = false,
  bottom = false,
  left = false,
  full = false,
  className,
  children,
  ...useIsActiveElementAttributes
}) => (
  <div
    className={getClassNames(top, right, bottom, left, full, className).highContrastBorder}
    {...useIsActiveElementAttributes}
  >
    {children}
  </div>
);

export default HighContrastBorder;
